import EnumDropdown, { EnumDropdownMultiProps, getItemsFromEnum } from '@/components/EnumDropdown';

import { LostAndFoundIssueReturnStatusEnum } from '@/models/gen/graphql';

const LostAndFoundIssueReturnStatusDropdown = (props: Omit<EnumDropdownMultiProps, 'enum'>): JSX.Element => (
  <EnumDropdown.Multi
    {...props}
    enum={getItemsFromEnum(LostAndFoundIssueReturnStatusEnum)}
    options={{ locale: { 'Select...': 'Return Status', Reportedlost: 'Reported Lost' } }}
  />
);

export default LostAndFoundIssueReturnStatusDropdown;
